import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  RootPage,
  GerminationPage,
  HealingPage,
  GreenhousePage,
  VehiclePage,
  TrayPage,
} from './pages';

const InfrastructurePage = (): JSX.Element => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}${ROUTES.dashboard.infrastructure.germinationRoom.root}`} component={GerminationPage} />
      <Route path={`${path}${ROUTES.dashboard.infrastructure.healingRoom.root}`} component={HealingPage} />
      <Route path={`${path}${ROUTES.dashboard.infrastructure.greenhouse.root}`} component={GreenhousePage} />
      <Route path={`${path}${ROUTES.dashboard.infrastructure.vehicle.root}`} component={VehiclePage} />
      <Route path={`${path}${ROUTES.dashboard.infrastructure.tray.root}`} component={TrayPage} />
      <Route path={`${path}`} component={RootPage} />
    </Switch>
  );
};

export default InfrastructurePage;
